import { createContext,useContext, useReducer } from "react";

export const AuthContext         =  createContext(null);
export const AuthDispatchContext =  createContext(null);

export function AuthProvider({children}) {

    const initAuthData = {
        isAuthenticated: false,
        userData : null,
        token:""
    }

    const [authData, dispatch] =  useReducer(AuthReducer, initAuthData);

    return(
        <AuthContext value={authData}>
            <AuthDispatchContext value={dispatch}>
                {children}
            </AuthDispatchContext>
        </AuthContext>
    )

}

// reference functions:
export function useAuthData()         {return(useContext(AuthContext))};
export function useAuthDispatch() {return(useContext(AuthDispatchContext))};

export function AuthReducer(authData,oAction) {

    let nAuthData;

    switch(oAction.type) {

        case 'signup':
            nAuthData = {...authData, isAuthenticated:false, userData : null };
        break;

        case 'login':
            nAuthData = {...authData, isAuthenticated:true, userData : oAction.oUserData};
        break;


        case 'logout':
            nAuthData = {...authData, isAuthenticated:false, userData:null};
        break;

        case 'setCurrUser':
            nAuthData = {...authData, isAuthenticated:true, userData : oAction.oUserData};
        break;

        default: //
    }

    return(nAuthData);

}